<template>
  
  <div>

    <div class="ui large breadcrumb">
      <a class="clickable" @click="$historyBack()">
        <i class="reply icon m-r-5"></i> Voltar
      </a>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>Visualizar Solicitação de Exame</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>    

    <div v-else class="animated fadeIn">

      <button v-if="showUpdateButton" class="ui button m-b-15" @click="$router.push(`/procs/exam-requests/${request.id}/form`) ">
        <i class="edit blue icon"></i> Alterar
      </button>

      <div class="ui grid">      

        <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
          <div class="ui segment">
            <h4 class="ui dividing header">Dados da Solicitação</h4>
            <div class="ui form">          
              <div class="fields">
                <div class="three wide field">
                  <label class="form-label">Número</label>
                  {{ request.id }}
                </div>
                <div class="six wide field">
                  <label class="form-label">Status</label>
                  <exam-request-status :status="request.status" />
                </div>
                <div class="seven wide field">
                  <label class="form-label">Data</label>
                  {{ $formatDate(request.date) }}
                </div>                
              </div>  
              <div class="fields">
                <div v-if="$isSimavet()" class="nine wide field">
                  <label class="form-label">Responsável</label>
                  {{ request.user.name.toUpperCase() + ' ' + request.user.lastName.toUpperCase() }}
                </div>                      
                <div class="seven wide field">
                  <label class="form-label">Veterinário</label>
                  {{ request.vetName.toUpperCase() }}
                </div>            
              </div>                           
              <div class="fields">                                                                
                <div class="sixteen wide field">
                  <label class="form-label">Clínica</label>
                  {{ request.customerName }}
                </div>      
              </div>
            </div>
          </div>
        </div>

        <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
          <div class="ui segment">
            <h4 class="ui dividing header">Animal</h4>
            <div class="ui form">          
              <div class="fields">
                <div class="five wide field">
                  <label class="form-label">Nome</label>
                  {{ request.animalName }}
                </div>
                <div class="six wide field">
                  <label class="form-label">Raça</label>
                  {{ request.raceName }}
                </div>
                <div class="five wide field">
                  <label class="form-label">Espécie</label>
                  {{ request.speciesName }}
                </div>                
              </div>  
              <div class="fields">                
                <div class="five wide field">
                  <label class="form-label">
                    Sexo
                    <i v-if="request.animalSex == 'male'" class="mars blue icon"></i>
                    <i v-if="request.animalSex == 'female'" class="venus pink icon"></i>
                    <i v-if="request.animalSex == 'undefined'" class="question circle grey icon"></i>
                  </label>
                  <span v-if="request.animalSex == 'male'">Macho</span>
                  <span v-if="request.animalSex == 'female'">Fêmea</span>
                  <span v-if="request.animalSex == 'undefined'">Indefinido</span>
                </div>  
                <div class="four wide field">
                  <label class="form-label">Idade</label>
                  {{ request.animalAge }}
                </div>
              </div> 
              <div class="fields">                
                <div class="sixteen wide field">
                  <label class="form-label">Nome do Tutor</label>
                  {{ request.ownerName }}
                </div>
              </div>                          
            </div>
          </div>
        </div>  

        <div class="sixteen wide column">
          <div class="ui segment">
            <h4 class="ui dividing header">Exame</h4>
            <div class="ui form">          
              <div class="fields">
                <div class="sixteen wide field">                  
                  <table class="ui celled selectable tablet stackable table m-t-10 m-b-15">
                    <thead v-if="$isDesktop">
                      <tr>
                        <th>Tipo do Exame</th>
                        <th>Número do Laudo</th>
                        <th>Status do Laudo</th>
                        <th></th>
                      </tr>  
                    </thead>
                    <tbody>
                      <tr v-for="type in request.examTypes">
                        <td>
                          <strong class="mobile-only">Tipo do Exame: </strong> {{ type.examType.description }}
                        </td>
                        <td>
                          <strong class="mobile-only">Número do Laudo: </strong> {{ type.certId }}
                        </td>                        
                        <td>
                          <strong class="mobile-only">Status do Laudo: </strong>
                          <cert-status v-if="type.certId" :status="type.cert.status" />
                        </td>    
                        <td style="width: 50px;">
                          <button v-if="type.certId" class="ui small icon button" @click="$router.push(`/procs/certs/${type.certId}/show?historyBack=true`)">
                            <i class="search plus icon"></i>
                          </button>
                        </td>                    
                      </tr>                
                    </tbody>
                  </table>
                </div>                                
              </div>                 
              <div class="fields">                
                <div class="sixteen wide field">
                  <label class="form-label">Suspeita Clínica</label>
                  <text-editor :readOnly="true" :contents="request.suspicionContents" />
                </div>
              </div>                          
            </div>
          </div>
        </div> 

      </div>

    </div>

  </div>

</template>  

<script>

  import ExamRequestService from "@/services/exam-request-service"
  import { CertStatus, ExamRequestStatus, TextEditor } from "@/components"

  export default {

    name: "ShowExamRequestPage",
    
    data() {
      return {
        loading: true,
        showUpdateButton: false,
        request: {},
        service: new ExamRequestService(),
      }
    },

    components: {
      CertStatus,
      ExamRequestStatus,
      TextEditor,
    },

    created() {
      this.loadRequest()
    },

    methods: {

      async loadRequest() {

        this.loading = true

        try {

          this.request = await this.service.findById(this.$route.params.id)

          if (this.$isVet() && this.request.userId !== this.$store.state.auth.user.id)
            return this.$router.push("/not-found")  

          this.showUpdateButton = this.service.canUpdate(this.request)

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },     
    },
  }

</script>